import Vue from "vue";
import VueRouter from "vue-router";
import LightBootstrap from "./light-bootstrap-main";
import "./assets/styles/global.css";
import { createPinia, PiniaVuePlugin } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import "@fortawesome/fontawesome-free/css/all.css";
import "element-ui/lib/theme-chalk/index.css";
import GlobalComponents from "./globalComponents";
import App from "./App.vue";
import PortalVue from "portal-vue";

import spinnerPlugin from "./plugins/spinner";
import modalPlugin from "./plugins/modal";

import router from "./routes/routes";

Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(PiniaVuePlugin);
Vue.use(GlobalComponents);
Vue.use(PortalVue);

const pinia = createPinia();
pinia.use(
    createPersistedState({
        storage: localStorage,
    }),
);
Vue.use(pinia);
Vue.use(spinnerPlugin);
Vue.use(modalPlugin);

/* eslint-disable no-new */
new Vue({
    el: "#app",
    render: (h) => h(App),
    router,
    pinia,
});
